<template>
  <div style="text-align: center">
    <div class="page-head-bottle-img mx-auto"></div>
  </div>
</template>

<script>
export default {
  name: "Bottle"
}
</script>

<style lang="scss">

</style>
